import { IProductList } from "../../../../models/product-v2";
import { ProductListItemVM } from "../../../../models/product-v3";

export class ProductV2Adapter {
  static toListVM(item: IProductList): ProductListItemVM {
    return {
      id: item.id,
      name: item.name,
      sku: item.sku,
      categoryName: item?.category?.name,
      status: item.status,
      imageUrl: ProductV2Adapter.getMainImage(item.images),
      isBundle: !!item.bundle,
      canEdit: true,
      canManageBundle: !!item.bundle,
    };
  }

  private static getMainImage(images?: { url?: string; order?: number }[]) {
    if (!images?.length) return undefined;
    const main = images.find(img => Number(img.order) === 0);
    return main?.url ?? images[0]?.url;
  }
}
